// Lib
import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import Link from '@mui/material/Link';
import WestIcon from '@mui/icons-material/West';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStyles } from './OrderHistoryButtonStyles';

const OrderHistoryButton = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { pathname } = useLocation();

  const onClick = useCallback(() => {
    if (pathname.includes('/order-history/recurring')) {
      return navigate('/order-history/recurring');
    }
    return navigate('/order-history');
  }, [navigate, pathname]);

  return (
    <Button
      component={Link}
      width={'fit-content'}
      className={classes.button}
      startIcon={<WestIcon />}
      onClick={onClick}
      data-testid="order-history-button">
      Order History
    </Button>
  );
};

export default OrderHistoryButton;
